export const REQUEST_CONTACT = "REQUEST_CONTACT";
export const RECEIVED_CONTACT = "RECEIVED_CONTACT";
export const ERROR_CONTACT = "ERROR_CONTACT";

export const CONTACT_NONE = "CONTACT_NONE";
export const CONTACT_REQUESTING = "CONTACT_REQUESTING";
export const CONTACT_RECEIVED = "CONTACT_RECEIVED";
export const CONTACT_ERROR = "CONTACT_ERROR";
